import { render, staticRenderFns } from "./psuBzjAffirmIndex.vue?vue&type=template&id=597d1f24"
import script from "./psuBzjAffirmIndex.vue?vue&type=script&lang=js"
export * from "./psuBzjAffirmIndex.vue?vue&type=script&lang=js"
import style0 from "./psuBzjAffirmIndex.vue?vue&type=style&index=0&id=597d1f24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports